import {
	Component,
	EventEmitter,
	Input,
	Output,
	AfterViewInit,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Address } from '@models/address';
import { Company, CompanyFields } from '@models/company';
import { LawFirm } from '@models/lawFirms';
import { Brokerage } from '@models/matter';
import { createId } from '@core/util/file';
import { TestHooks } from './create-company-side-form.hooks';

@Component({
	selector: 'app-create-company-side-form',
	templateUrl: './create-company-side-form.component.html',
	standalone: false,
})
export class CreateCompanySideFormComponent implements AfterViewInit {
	testHooks = TestHooks;
	public _id;
	public _name = '';
	public _phoneNumber = '';
	public _fax = '';
	public _email = '';
	public _website = '';
	public _address: Address = null;
	public loading = false;

	@Input() minify = false;
	protected addressChanged: boolean = false;

	@Input() set company(value: Brokerage | LawFirm) {
		this._id = value?.id ?? null;
		this._fax = value?.faxNumber ?? null;
		this._email = value?.email ?? null;
		this._phoneNumber = value?.phoneNumber ?? null;
		this._address = value?.address ?? null;
	}

	@Input() label = '';
	@Input() set name(value: string) {
		this._name = value;
	}

	@Output() onSubmit = new EventEmitter<Company>();
	@Output() onCancel = new EventEmitter();

	labels = CompanyFields;

	ngAfterViewInit(): void {
		this.loading = false;
	}

	_onSubmit(form: NgForm): void {
		if (form.valid) {
			this.loading = true;
			const company: Company = {
				id: this._id ? this._id : createId(),
				name: this._name,
				phoneNumber: this._phoneNumber,
				faxNumber: this._fax,
				email: this._email,
				address: this._address ?? null,
				website: this._website,
			};
			this.onSubmit.emit(company);
		}
	}

	_onCancel() {
		this.onCancel.emit();
	}

	onAddressUpdate($event) {
		this._address = $event;
		this.addressChanged = true;
	}
}
